import { Map } from 'immutable';
import { 
	FILL_SELL_PAYMENTS,
	FILL_SELL_PAYMENT,
	CLEAR_SELL_PAYMENTS ,
	SET_PAYMENT_TOTAL,
} from '../constants/actionTypes.js'

const initialState = Map({
	payments: [],
	payment: {},
	paymentTotal: 0,
});

export default (state = initialState, action) => {

	switch (action.type) {

		case FILL_SELL_PAYMENTS:
      return state.set('payments', action.payload.payments);

		case FILL_SELL_PAYMENT:
			return state.set('payment', action.payload.payment);

		case SET_PAYMENT_TOTAL:
			return state.set('paymentTotal', action.payload.paymentTotal);

		case CLEAR_SELL_PAYMENTS:
			return initialState;

		default:
			return state;
	}
};
